export const Contact = `
    contact {
        pocid
        name
        cell
        land
        email
        pubconinfo
        instruc
        datelastchanged
    }
`;
